export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://panel-api.medadrangischool.ir';

export const API_PREFIX = process.env.REACT_APP_API_PREFIX || '';

export const API_URL = `${API_BASE_URL}${API_PREFIX}`;

export function buildApiUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${API_URL}${normalizedPath}`;
}

export function buildFileUrl(path = '') {
  if (!path) {
    return '';
  }

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  const filesPath = normalizedPath.startsWith('files/') ? normalizedPath : `files/${normalizedPath}`;

  return buildApiUrl(filesPath);
}
